import { BiBox, BiCartAlt, BiHelpCircle, BiHomeAlt, BiNews, BiSolidBellRing, BiSupport } from "react-icons/bi";

export const NavmenuItemsData = [
  {
    isChild: false,
    title: "Dashboard",
    url: "/dashboard",
    Icon: BiHomeAlt,
  },
  {
    title: "My Order",
    url: "/products",
    Icon: BiCartAlt,
  },
  {
    title: "Other Reminder",
    url: "/other-reminder",
    Icon: BiSolidBellRing,
  },
  {
    title: "Inquiry",
    url: "/product-inquiry",
    Icon: BiBox,
  },
  {
    title: "Support",
    url: "/support",
    Icon: BiSupport,
  },
  {
    title: "News & Knowledge",
    url: "/News",
    Icon: BiNews,
  },
  {
    title: "Help",
    url: "/help",
    Icon: BiHelpCircle,
  },
];
